// @flow
import React from 'react';
import Flex from '@waglabs/flex';
import Box from '@waglabs/box';
import Icon from '@waglabs/icon';
import Text from '@waglabs/text';
import Link from '@waglabs/link';

import {
  routes,
} from '../..';
import {
  COMING_SOON,
} from '../../../../constants';

import { Button } from '../../../Button';

type Props = {
  isMobileMenuVisible: boolean,
};

const getRouteById = (routesList, id) => {
  const route = routes.find(routeInList => routeInList.id === id);
  if (route) {
    return route;
  }

  return {
    id: undefined,
    path: '',
    label: '',
  };
};

const MobileNavigation = ({
  isMobileMenuVisible,
  ...rest
}: Props) => (
  <Flex
    flexDirection="column"
    position="fixed"
    zIndex={2}
    left={isMobileMenuVisible ? 0 : -250}
    transition="0.2s ease-in-out left"
    width={250}
    bg="white"
    boxSizing="border-box"
    {...rest}
  >
    {routes.map((route) => {
      if (route.id !== 0) {
        return (
          <Flex
            key={route.id}
            flexDirection="column"
            boxSizing="border-box"
            borderBottom={route.id === 1 || route.id === 4 ? 1 : 0}
            borderColor="backgroundGray"
          >
            {/* Services */}
            {route.id === 1
              && (
                <Flex
                  flexDirection="column"
                >
                  <Text
                    color="wagGray"
                    fontFamily="body"
                    textTransform="uppercase"
                    fontWeight="bold"
                    m={0}
                    px={3}
                    pt={3}
                    pb={9}
                  >
                    {route.label}
                  </Text>
                  {route.subRoutes.map(subRoute => (
                    <Link
                      key={subRoute.id}
                      href={subRoute.path}
                    >
                      <Text
                        color="medGray"
                        fontFamily="body"
                        ml={30}
                        display="inline-block"
                        hover
                      >
                        {subRoute.label}
                      </Text>
                      {subRoute.status === COMING_SOON && (
                        <Text
                          color="wagGold"
                          display="inline-block"
                          fontFamily="heading"
                          fontSize={0}
                          ml={1}
                        >
                          Coming Soon!
                        </Text>
                      )}
                    </Link>
                  ))}
                </Flex>
              )
            }
            {/* FAQ, Blog, Login */}
            {route.id !== 1
              && (
                <Link
                  href={route.path}
                >
                  <Text
                    color="medGray"
                    fontFamily="body"
                    ml={3}
                    hover
                  >
                    {route.label}
                  </Text>
                </Link>
              )}
          </Flex>
        );
      }
      return null;
    })}
    {/* Become a Walker */}
    <Box
      p={2}
      pt={3}
    >
      <Link
        href={getRouteById(routes, 0).path}
      >
        <Button
          variant="primary"
          width={1}
          hover
        >
          <Flex
            alignItems="center"
            hover
          >
            <Icon
              name="walker"
              mr={2}
              hover
            />
            <Text
              textTransform="uppercase"
              fontFamily="body"
              color="darkRed"
              m={0}
              hover
            >
              {getRouteById(routes, 0).label}
            </Text>
          </Flex>
        </Button>
      </Link>
    </Box>
  </Flex>
);

export default MobileNavigation;
